<script>
    import IconButton from "../../../inputs/IconButton/v1/IconButton.svelte";
    import { formatLanguageString } from '@itslearning/atlas/strings/format';
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    /** @type {Array} */
    export let actions = [];
    /** @type {Array} */
    export let selections = [];
    /** @type {object} */
    export let i18n;
    /** @type {number} */
    export let totalNumberOfRows;
    /** @type {string|undefined} */
    export let description = undefined;

    $: selectionText = formatLanguageString(i18n.selected, selections.length.toString(), totalNumberOfRows.toString());
</script>

<aside class="prom-table-panel" aria-label={description}>
    <span class="prom-table-panel__selected-text" aria-live="assertive">
        {selectionText}
    </span>
    <div class="prom-table-panel__actions">
        {#if selections.length !== 0}
            <div class="prom-table-panel__action-items">
                {#each actions as action}
                    <IconButton 
                        text={action.text}
                        type="plain"
                        htmlType="button"
                        iconClass={action.iconClass}
                        on:click={() => dispatch(action.event)}
                    />
                {/each}
            </div>
            <div class="prom-table-panel__clear-selection">
                <IconButton 
                    text={i18n.clearSelection}
                    type="plain"
                    htmlType="button"
                    iconClass="clear-icon"
                    on:click={() => dispatch("clearAll")}
                />
            </div>
        {/if}
    </div>
</aside>
